import React from "react";
import image547 from "../assets/image547.png";
import image548 from "../assets/image548.png";
import image549 from "../assets/image549.png";
import photo1 from "../assets/photo1.png";
import photo2 from "../assets/srikanth_anna_latest.png";

import { motion } from "framer-motion";

const AboutUs = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="bg-[#d2e5e4] px-6 py-20 font-sans overflow-hidden -mt-10">
        <div className="max-w-6xl mx-auto flex flex-col-reverse md:flex-row items-center gap-10 text-left md:text-left">
          {/* Text Content */}
          <motion.div
            className="w-full md:w-1/2"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            viewport={{ once: false }}
          >
            <h1 className="text-4xl sm:text-6xl font-bold text-[#3d302c] mb-6 leading-tight">
              Simplifying <br /> Healthcare, <br /> One Click at a Time.
            </h1>
            <p className="text-lg text-[#3d302c] mb-8">
              Our commitment is to a future where healthcare is not just about
              treatment but about unmatched convenience and efficiency for both
              providers and recipients. By integrating AI into the very fabric
              of healthcare management, we are not just envisioning a paperless
              future; we are actively creating it.
            </p>
            <button className="bg-[#3d302c] text-white px-6 py-3 rounded-md font-semibold hover:bg-[#2e251f] transition">
              Request a Demo
            </button>
          </motion.div>

          {/* Image */}
          <motion.div
            className="w-full md:w-1/2 flex justify-center"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.1 }}
            viewport={{ once: false }}
          >
            <img
              src={image547}
              alt="Smiling Doctor Coming Soon"
              className="w-full max-w-[280px] sm:max-w-[340px] md:max-w-[400px] rounded-xl shadow-lg"
            />
          </motion.div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="bg-white text-[#3d302c] px-6 py-20 font-sans overflow-hidden -mt-10">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10 text-left md:text-left">
          {/* Image */}
          <motion.div
            className="w-full md:w-1/2 flex justify-center"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            viewport={{ once: false }}
          >
            <img
              src={image548}
              alt="Illustration representing MedOps mission"
              className="w-full max-w-sm sm:max-w-md md:max-w-lg rounded-xl shadow-lg"
            />
          </motion.div>

          {/* Text */}
          <motion.div
            className="w-full md:w-1/2"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.1 }}
            viewport={{ once: false }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Mission</h2>
            <p className="mb-4 text-lg leading-relaxed">
              Our mission at{" "}
              <span className="font-semibold text-[#f0b83d]">Medimind</span> is
              to build intelligent, unified healthcare platforms that transform
              data into clinical intelligence, empowering providers to make more
              informed, efficient decisions.
            </p>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-lg">
              <li className="border border-gray-400 rounded-lg px-3 py-2 text-center shadow-sm">
                Quick support
              </li>
              <li className="border border-gray-400 rounded-lg px-3 py-2 text-center shadow-sm">
                24/7 availability
              </li>
            </ul>
          </motion.div>
        </div>
      </section>

      {/* Our Vision Section */}
      <section className="bg-[#fdfdfd] text-[#3d302c] px-6 py-20 font-sans overflow-hidden -mt-10">
        <div className="max-w-6xl mx-auto flex flex-col-reverse md:flex-row items-center gap-10 text-left md:text-left">
          {/* Text */}
          <motion.div
            className="w-full md:w-1/2"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.2 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Vision</h2>
            <p className="mb-4 text-lg leading-relaxed">
              Our vision at{" "}
              <span className="font-semibold text-[#f0b83d]">Medimind</span> is
              to empower every healthcare provider with intelligent technology,
              enabling them to deliver exceptional patient outcomes and a better
              quality of life for all.
            </p>

            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-lg">
              <li className="border border-gray-400 rounded-lg px-3 py-2 text-center shadow-sm">
                100% Customer Satisfaction
              </li>
              <li className="border border-gray-400 rounded-lg px-3 py-2 text-center shadow-sm">
                Customer Centric
              </li>
              <li className="border border-gray-400 rounded-lg px-3 py-2 text-center shadow-sm">
                Free Consultation
              </li>
              <li className="border border-gray-400 rounded-lg px-3 py-2 text-center shadow-sm">
                Always Doctors
              </li>
            </ul>
          </motion.div>

          {/* Image */}
          <motion.div
            className="w-full md:w-1/2 flex justify-center"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.2 }}
          >
            <img
              src={image549}
              alt="Illustration representing MedOps vision"
              className="w-full max-w-sm sm:max-w-md md:max-w-lg rounded-xl shadow-lg"
            />
          </motion.div>
        </div>

        {/* Leadership Team Section - COMMENTED OUT (use false && to avoid nested comment issues) */}
        {false && (
          <section className="bg-white text-[#3d302c] px-6 py-20 font-sans overflow-hidden ">
            <div className="max-w-6xl mx-auto text-center ">
              <h2 className="text-3xl md:text-4xl font-bold mb-12">
                Executive Leadership Council
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-10 justify-center">
                {/* Leader 1 */}
                <motion.div
                  className="flex flex-col items-center bg-gray-50 p-6 rounded-xl shadow-md"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: false }}
                >
                  <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-gray-200 shadow-md">
                    <img
                      src={photo1}
                      alt="Ashok Dandamudi"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="mt-4 text-xl font-semibold">Ashok Dandamudi</h3>
                  <p className="text-gray-600">Chief Executive Officer</p>
                </motion.div>

                {/* Leader 2 */}
                <motion.div
                  className="flex flex-col items-center bg-gray-50 p-6 rounded-xl shadow-md"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: false }}
                >
                  <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-gray-200 shadow-md">
                    <img
                      src={photo2}
                      alt="Srikanth Bonkuri"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="mt-4 text-xl font-semibold">Srikanth Bonkuri</h3>
                  <p className="text-gray-600">Managing Director & Head of Technology</p>
                </motion.div>

                {/* Leader 3 */}
                <motion.div
                  className="flex flex-col items-center bg-gray-50 p-6 rounded-xl shadow-md"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: false }}
                >
                  <div className="w-32 h-32 flex items-center justify-center rounded-full border-4 border-gray-200 shadow-md bg-gray-100 text-gray-500 text-sm">
                    Sandeep Alla
                  </div>
                  <h3 className="mt-4 text-xl font-semibold">Sandeep Alla</h3>
                  <p className="text-gray-600">Head of Operations</p>
                </motion.div>
              </div>
            </div>
          </section>
        )}
      </section>
    </>
  );
};

export default AboutUs;
